import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { useIntl } from 'ha/i18n';
import { Typography, Grid } from '@hbf/dsl';

const useStyles = makeStyles()(theme => ({
  label: {
    color: theme.palette.grey[600],
  },
}));

export const AddressDetails: React.FC = () => {
  const { classes } = useStyles();
  const { T } = useIntl();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography.ParagraphTitle component="div">
          HousingAnywhere B.V.
        </Typography.ParagraphTitle>
      </Grid>
      <Grid item xs={12}>
        <Typography.Paragraph component="div">
          <div className={classes.label}>{T('Chamber of Commerce number')}</div>
          <div>{T('58882693')}</div>
        </Typography.Paragraph>
      </Grid>
      <Grid item xs={12}>
        <Typography.Paragraph component="div">
          <div className={classes.label}>{T('contact_us_location')}</div>
          <div>{T('Hofplein 20 in Rotterdam, Netherlands')}</div>
        </Typography.Paragraph>
      </Grid>
      <Grid item xs={12}>
        <Typography.Paragraph component="div">
          <div className={classes.label}>{T('VAT number')}</div>
          <div>{T('NL853222368B01')}</div>
        </Typography.Paragraph>
      </Grid>
    </Grid>
  );
};
